import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react';

import { cn } from 'app/utils/styles.utils';
import { InputVariantProps, inputVariants } from 'app/theme/input';

export type InputProps = DetailedHTMLProps<
  Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>,
  HTMLInputElement
> &
  InputVariantProps;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({className, children, variant, size, ...props}, ref) => {
    return (
      <input
        ref={ref}
        className={cn(inputVariants({variant, size}), className)}
        {...props}>
        {children}
      </input>
    );
  },
);

Input.displayName = 'Input';
